/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// axios
import axios from './axios.js'

// ADDS BEARER JWT TO EVERY REQUEST
axios.interceptors.request.use(
  function(config) {
    let jwt = localStorage.getItem('accessToken')
    if (jwt !== '') config.headers.common['Authorization'] = `Bearer ${jwt}`

    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    if (error.response.status == 401) {
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$http = axios

// API Calls
import './http/requests'

// Theme Configurations
import '../themeConfig.js'

// Auth0 Plugin
import AuthPlugin from './plugins/auth'

Vue.use(AuthPlugin)

// ACL
import acl from './acl/acl'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'


// Vuexy Admin Filters
import './filters/filters'

// MomentJS - Date
import moment from 'vue-moment'

Vue.use(moment)

// Clipboard
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// Tour
import VueTour from 'vue-tour'

Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

// VeeValidate
import VeeValidate from 'vee-validate'
// Vue.use(VeeValidate);
Vue.use(VeeValidate, {inject: false})

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyB4DDathvvwuwlwnUu7F4Sow3oU22y5T1Y',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'

Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

//Lightbox
import VueLazyLoad from 'vue-lazyload'
import LightBox from 'vue-image-lightbox'

Vue.config.productionTip = false

new Vue({
  router,
  store,

  acl,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueLazyLoad)
Vue.use(LightBox)
